<template>
  <div class="accessory-reference-root-container">
    <div class="accessory-reference-header-container">
      <span style="font-size: 12px; font-weight: 500; color: #000000"
        >附件</span
      >
      <span
        v-if="canShowBtn"
        @click="$emit('upload')"
        style="
          font-size: 12px;
          font-weight: 500;
          color: #3b73bb;
          cursor: pointer;
        "
        >上传</span
      >
    </div>
    <div class="accessory-reference-main-container">
      <accessories-item
        v-for="item in dataSource"
        :key="item.file_url"
        :data-source="item"
        style="margin-bottom: 10px; width: 100%; min-width: 170px"
      />
    </div>
  </div>
</template>

<script>
import AccessoriesItem from "../Item/AccessoriesItem";
export default {
  components: {
    "accessories-item": AccessoriesItem,
  },
  props: {
    dataSource: Array,
    canShowBtn: Boolean,
  },
};
</script>

<style scoped>
.accessory-reference-root-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: hidden;
}
.accessory-reference-main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: scroll;
}
.accessory-reference-header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>